<template>
  <div class="vueComponent" id="VueSignalStrength">
    <a :href="signalLink" class="plain-link">
      <span :class="signalClass" :title="signalTitle"></span>
    </a>
  </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
  name: "SignalStrengthIcon",
  mixins: [SonicuCoreMixin],
  props: {
    signalStrength: {
      type: Number,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    companyId: {
      type: String,
      required: false,
    },
    radioType: {
      type: String,
      default: 'cell',
    }
  },
  computed: {
    signalClass: function () {
      return this.signalTextColor + " " + this.signalIcon;
    },
    signalTitle: function () {
      if(this.radioType === 'unknown'){
        return 'Radio type not synced';
      }

      if (this.signalStrength < 20) {
        return 'Signal Strength: Weak';
      } else if (this.signalStrength < 40) {
        return 'Signal Strength: Okay';
      } else if (this.signalStrength < 60) {
        return 'Signal Strength: Good';
      } else if (this.signalStrength < 80) {
        return 'Signal Strength: Great';
      } else {
        return 'Signal Strength: Excellent';
      }
    },
    signalLink: function () {
      return this.company.buildCompanyRoute(`meters/${this.id}`)
    },
    signalTextColor() {
      if (this.signalStrength === 0) {
        return 'text-red-700';
      } else if (this.signalStrength < 20) {
        return 'text-red-700';
      } else if (this.signalStrength < 40) {
        return 'text-yellow-400';
      } else if (this.signalStrength < 60) {
        return 'text-yellow-400';
      } else if (this.signalStrength < 80) {
        return 'text-green-600';
      } else {
        return 'text-green-600';
      }
    },
    signalIcon() {
      if(this.radioType === 'unknown'){
        return 'lnr icon-cloud-crossed';
      }

      if (this.radioType === 'wifi') {
        if (this.signalStrength === 0) {
          return 'lnr icon-wifi-blocked';
        } else if (this.signalStrength < 20) {
          return 'lnr icon-wifi-alert-low2';
        } else if (this.signalStrength < 40) {
          return 'lnr icon-wifi-alert-mid';
        } else if (this.signalStrength < 60) {
          return 'lnr icon-wifi-mid';
        } else if (this.signalStrength < 80) {
          return 'lnr icon-wifi';
        } else {
          return 'lnr icon-wifi';
        }
      }

      if (this.radioType === 'sonilink') {
        if (this.signalStrength < 30) {
          return 'lnr icon-unlink';
        } else {
          return 'lnr icon-link';
        }
      }

      if (this.signalStrength === 0) {
        return 'lnr icon-signal-0';
      } else if (this.signalStrength < 20) {
        return 'lnr icon-signal-20';
      } else if (this.signalStrength < 40) {
        return 'lnr icon-signal-40';
      } else if (this.signalStrength < 60) {
        return 'lnr icon-signal-60';
      } else if (this.signalStrength < 80) {
        return 'lnr icon-signal-80';
      } else {
        return 'lnr icon-signal';
      }
    }
  }
}
</script>

<style scoped>

</style>